import { useContext, useState } from 'react';
import Context, { AccessContext } from './context.js';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faEnvelope, faMessage } from '@fortawesome/free-regular-svg-icons';
import { faRepeat, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import userPlaceholder from '../images/placeholder-user.png';

const Header = () => {
    const [context] = useContext(Context);
    const { firstName, lastName, isSuper, speakerName } = useContext(AccessContext);
    const { podcastName, role, podcastImage } = useContext(AccessContext);
    const [userMenuVisible, setUserMenuVisible] = useState(false);
    const navigate = useNavigate();
    const logout = () => {
        localStorage.removeItem('jwt');
        navigate('/login');
    }
    return (
        <header>
            <div className="flex gap-5 f-start w-100">
                <div className="logo-container">
                    <img src="/podcast-premium-logo.png" alt="Podcast Premium Logo" height="48" />
                </div>
                {(!!podcastImage || !!podcastName) && (
                    <h1 className="">
                        {!!podcastImage && (
                            <img src={podcastImage.startsWith('http') ? podcastImage : process.env.REACT_APP_MEDIA_URL + '/' + podcastImage} alt="Podcast Logo" height="48" />
                        )}
                        {!!podcastName && <span>{podcastName}</span>}
                    </h1>
                )}
                <div className="flex f-end gap-10 mobile-hide ml-auto">
                    <Link to="/" title="Notifications">
                        <FontAwesomeIcon icon={faBell} />
                    </Link>
                    <Link to="/" title="Emails">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </Link>
                    <Link to="/" title="Messages">
                        <FontAwesomeIcon icon={faMessage} />
                    </Link>
                    <div className="user-profile">
                        <div className="flex f-row gap-10">
                            <div className="flex f-col f-end mt-auto">
                                <div className="user-name">{firstName} {lastName} {isSuper && speakerName && role == 'Host/Guest' && <>[{speakerName}]</>}</div>
                                <div className="user-role">{isSuper && role != 'Super' ? <>Super [{role}]</> : role}</div>
                            </div>
                            <img className="user-image" src={userPlaceholder} alt="User Profile" height="40" onClick={() => {
                                if (userMenuVisible) return;
                                setUserMenuVisible(true);
                                setTimeout(() => {
                                    const hideMenu = (e) => {
                                        console.log(userMenuVisible);
                                        setUserMenuVisible(false);
                                        document.removeEventListener('click', hideMenu);
                                    }
                                    document.addEventListener('click', hideMenu);
                                });
                            }} />
                        </div>
                        <div className={"user-menu" + (userMenuVisible ? " active" : "")}>
                            <Link to="/settings">
                                Settings
                            </Link>
                            {isSuper && (
                                <>
                                    <Link to="/protected/podcast-select">
                                        Switch View
                                    </Link>
                                    <Link to="/template-list">
                                        Email Templates
                                    </Link>
                                </>
                            )}
                            <a role="button" onClick={logout}>
                                Log Out
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;